import { observable, runInAction } from 'mobx';
import { get, post} from '../utils';

/**
 * 商品布局列表
 */
class ProductLayoutList {
    private route: string;
    private params: any;
    @observable
    public list: any[] = [];
    @observable
    public selectedLayout: any = null;
    @observable
    public userInfo: any = null;

    constructor(params?: any) {
        this.route = 'newproduct/v1/layout/list';
        this.params = params || {};
    }

    /**
     * 获取用户信息
     */
    async getUserInfo(callback?, errs?) {
        return get('user/weixin/v1/info', {}).then((res) => {
            if (res.errCode === 200 && res.data) {
                runInAction(() => {
                    this.userInfo = res.data;
                });
                callback && callback(res.data);
                return res.data;
            } else {
                errs && errs(res);
                return null;
            }
        }).catch((err) => {
            errs && errs(err);
            return null;
        });
    }

    async fetch(callback?, errs?) {
        // 先获取用户信息
        const userData = await this.getUserInfo();
        
        // 如果用户未登录，不调用布局列表接口
        if (!userData || !userData.id) {
            console.log('用户未登录，跳过获取布局列表');
            callback && callback([]);
            return;
        }
        
        // 使用获取到的用户id调用布局列表接口
        const requestParams = {
            ...this.params,
            userId: userData.id
        };
        
        get(this.route, requestParams).then((d) => {
            let data: any;
            if (d.errCode != 200) {
                errs && errs(d.errCode);
                return;
            } else {
                if (d.data) {
                    data = d.data;
                    runInAction(() => {
                        this.list = data || [];
                        // 找出已选中的布局
                        this.selectedLayout = this.list.find(item => item.isSelected === 1);
                        callback && callback(data);
                    });
                } else {
                    callback && callback([]);
                }
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }

    /**
     * 保存用户布局选择
     * @param layoutId 布局ID
     * @param callback 回调
     * @param errs 错误回调
     */
    async saveUserLayout(layoutId: number, callback?, errs?) {
        // 先获取用户信息
        const userData = await this.getUserInfo();
        
        // 如果用户未登录，不能保存
        if (!userData || !userData.id) {
            console.log('用户未登录，无法保存布局选择');
            errs && errs({ message: '用户未登录' });
            return;
        }
        
        const requestParams = {
            layoutId,
            userId: userData.id
        };
        
        post('newproduct/v1/insert/layout/user', requestParams).then((d) => {
            if (d.errCode != 200) {
                errs && errs(d.errCode);
                return;
            } else {
                // 更新本地选中状态
                runInAction(() => {
                    this.list = this.list.map(item => ({
                        ...item,
                        isSelected: item.id === layoutId ? 1 : 0
                    }));
                    this.selectedLayout = this.list.find(item => item.id === layoutId);
                });
                callback && callback(d);
            }
        }).catch((err) => {
            errs && errs(err);
        });
    }
}

export default ProductLayoutList;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/model/ProductLayoutList.ts